import Menus from "../Menus";

const HelpTopicRechercheConseils = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: 'Rechercher des conseils', link: '/topics/rechercher/recherche-conseils'},
  ]

  const multiMenus = [
    {title: 'Fonctionnement des recherches', filter: 'HelpTopicRechercheConseils_1'},
    {title: 'Comprendre les annonces', filter: 'HelpTopicRechercheConseils_2'},
    {title: 'Enregistrer vos favoris', filter: 'HelpTopicRechercheConseils_3'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicRechercheConseils